document.addEventListener('DOMContentLoaded', function() {
    var swiper = new Swiper(".Images-sliderOuter", {
       slidesPerView: 7,
       loop: true,
       spaceBetween: 10,
      breakpoints: {
        1024: { slidesPerView: 7,},
        768: { slidesPerView: 4,},
        640: { slidesPerView: 3,},
        320: { slidesPerView: 3,}
      }
    });

      var swiper = new Swiper(".testimonials-outer", {
         slidesPerView: 3,
         loop: true,
         spaceBetween: 10,
         breakpoints: {
          1024: { slidesPerView: 3,},
          768: { slidesPerView: 1,},
          640: { slidesPerView: 1,},
          320: { slidesPerView: 1,}
        }
      });

     var swiper = new Swiper(".upsell-products-container", {
      slidesPerView: 3,
      loop: true,
      spaceBetween: 10,
        pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
          1024: { slidesPerView: 3 },
          768: { slidesPerView: 2 },
          640: { slidesPerView: 2 },
          320: { slidesPerView: 2 }
      },
  });

  });


$(document).ready(function(){
  $('.grid__item').hover(
    function() {
      $(this).addClass('hovered');
    },
    function() {
      $(this).removeClass('hovered');
    }
  );
  
    $('.policies-inner').wrapAll('<div class="policies-outer-div"></div>');
});

